export default "__VITE_ASSET__D0egJleh__"